import { Button, CheckSmallCircleFillIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
interface StandardPickerDialogFooterProps {
  selectedCount: number;
  maxCount: number;
  onConfirm: () => void;
  disabled: boolean;
}

/**
 * 성취기준 선택 모달의 푸터 컴포넌트
 * 선택 개수 표시 및 확인 버튼을 제공합니다.
 */
export const StandardPickerDialogFooter = ({
  selectedCount,
  maxCount,
  onConfirm,
  disabled
}: StandardPickerDialogFooterProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex items-center justify-between border-t border-gray-200 bg-white px-6 py-4" data-sentry-component="StandardPickerDialogFooter" data-sentry-source-file="StandardPickerDialogFooter.tsx">
      {/* 선택 개수 표시 */}
      <div className="text-body-sm-semibold text-alternative">
        {t('build:build.standard.modal.footer.selected')}{' '}
        <span className="font-semibold">{selectedCount}</span> / {maxCount}
      </div>

      {/* 선택 완료 버튼 */}
      <Button onClick={onConfirm} disabled={disabled} variant="contained" size="lg" leftSlot={<CheckSmallCircleFillIcon size="md" />} data-sentry-element="Button" data-sentry-source-file="StandardPickerDialogFooter.tsx">
        {t('build:build.standard.modal.footer.confirm')}
      </Button>
    </div>;
};